import { render, staticRenderFns } from "./QuestionTitle.vue?vue&type=template&id=66f6aaba&"
import script from "./QuestionTitle.vue?vue&type=script&setup=true&lang=ts&"
export * from "./QuestionTitle.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports